import { t } from 'i18next';
import axiosInstance from '../../../../../axiosInstance';
import { checkRequired, removeUndefined } from './validationUtils';

const validateLength = (key, value, min, max) => {
  if (value.length < min) {
    return t('workflowWizard.nameTooShort', { key, min });
  }
  if (value.length > max) {
    return t('workflowWizard.nameTooLong', { key, max });
  }
};

const checkNameExists = async (name, versionId, saveAsTemplate) => {
  try {
    // Excluding the current versionId from the check
    let response;
    if (saveAsTemplate) {
      response = await axiosInstance.get(
        `/api/workflows-template/checkName/${name}`
      );
    } else {
      response = await axiosInstance.get(
        `/api/workflows/version/checkName/${name}/exld/${versionId}`
      );
    }

    if (response.status === 200 && response.data.exists) {
      return t('workflowWizard.nameExists');
    }
  } catch (error) {
    return t('workflowWizard.nameExists');
  }
};

const validateImageSize = (workflowImage, maxSizeMB = 5) => {
  if (
    !workflowImage ||
    !Array.isArray(workflowImage) ||
    workflowImage.length === 0
  ) {
    return undefined;
  }

  const image = workflowImage[0];
  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  if (image.size && image.size > maxSizeBytes) {
    return t('workflowWizard.imageSizeExceeds', {
      size: (image.size / 1024 / 1024).toFixed(2),
      max: maxSizeMB,
    });
  }

  return undefined;
};

const validate = async ({
  name,
  description,
  versionId,
  saveAsTemplate,
  workflowImage,
  payment_enabled,
  payment_provider_id,
  payment_currency,
}) => {
  const errors = removeUndefined({
    name:
      checkRequired(name, 'workflowWizard.required') ||
      (name && validateLength('Name', name, 3, 50)),
    workflowImage: validateImageSize(workflowImage, 5),
  });

  if (description && description.length >= 500) {
    errors.description = t('workflowWizard.descriptionTooLong');
    return errors;
  }

  if (!errors.name) {
    const nameError = await checkNameExists(name, versionId, saveAsTemplate);
    if (nameError) {
      errors.name = nameError;
    }
  }

  if (payment_enabled) {
    if (!payment_provider_id) {
      errors.payment_provider_id = t('workflowWizard.paymentProviderRequired');
    }
    if (!payment_currency) {
      errors.payment_currency = t('workflowWizard.paymentCurrencyRequired');
    }
  }

  return errors;
};

export default validate;
